const useRozeniteDevTools = () => {};

export const RozeniteDevToolsProvider = ({ children }: { children: React.ReactNode }) => {
    useRozeniteDevTools();
    return <>{children}</>;
};
